import { useWallet } from "@manahippo/aptos-wallet-adapter";
import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import React, { useState, useEffect } from "react";

import Button from "../../components/Common/Button";
import Card from "../../components/Common/Card";
import TransactionDialog from "../../components/Common/TransactionDialog";
import Divider from "../../components/Divider";
import LoginWallet from "../../components/LoginWallet";
import InputDateInCard from "../../components/Vest/InputDateInCard";
import InputInCard from "../../components/Vest/InputInCard";
import { getTransactionByHash } from "../../libs/aptos_sdk";
import coins from "../../libs/coins/coins.json";
import { lock_vest } from "../../libs/swap_sdk";
import {
  getDateFormat1,
  lockingString,
  sleep,
  vePowerString,
} from "../../utils/common";

export default function CreateVest() {
  const inRef = React.createRef();
  const { signAndSubmitTransaction, account } = useWallet();
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [lockBtnDisable, setBtnLockDisable] = useState<boolean>(true);
  const [lockBtnText, setLockBtnText] = useState<string>("Enter an amount");
  const [step, setStep] = useState<number>(0);
  const [inSymbol, outSymbol] = ["FOIL", "feNFT"];
  const [inAmount, setInAmount] = useState("0");
  const [inCoin] = useState<string>(coins[4].address); //foil coin
  const [txn, setTxn] = useState<string>("");
  const now = Math.floor(new Date().getTime() / 1000);
  const [lockDuration, setLockDuration] = useState<number>(now + 7 * 86400);

  useEffect(() => {
    if (inRef && inRef.current) {
      // @ts-ignore
      const balanceIn = inRef.current.balance;
      if (Number(inAmount) > Number(balanceIn)) {
        setBtnLockDisable(true);
        setLockBtnText("Insufficient in coin balance");
      } else if (Number(inAmount) > 0) {
        setBtnLockDisable(false);
        setLockBtnText("Lock");
      } else {
        setBtnLockDisable(true);
        setLockBtnText("Enter an amount");
      }
    }
  }, [inAmount, inRef]);

  const handleCloseAlert = () => setOpenAlert(false);

  const handle_lock = async () => {
    setTxn("");
    setOpenAlert(true);
    setStep(0);
    const lock = lockDuration - now;

    const data = await lock_vest(
      signAndSubmitTransaction,
      Number(inAmount) * Math.pow(10, 9),
      lock
    );

    setTxn(data.hash);
    setStep(1);
    let transaction;
    while (!transaction) {
      try {
        transaction = await getTransactionByHash(data.hash);
      } catch {
        await sleep(500);
      }
    }
    setStep(2);
  };

  const handle_in_amount = async (v: any) => {
    setInAmount(v);
  };

  const changeDateOption = (e: any, value: string) => {
    if (value === "1 week") {
      setLockDuration(now + 7 * 86400);
    } else if (value === "1 month") {
      setLockDuration(now + 30 * 86400);
    } else if (value === "1 year") {
      setLockDuration(now + 365 * 86400);
    } else if (value === "4 years") {
      setLockDuration(now + 4 * 365 * 86400);
    }
  };
  return (
    <div className="overflow-auto no-scrollbar flex items-center justify-center h-screen">
      <div className="flex flex-col w-2/5 max-2xl:w-3/5 max-xl:w-3/4 max-sm:w-full px-4 max-sm:px-2">
        <Card>
          <div className="flex justify-between items-center py-4 px-4">
            <div className="text-white text-xl font-normal">
              Create New Lock
            </div>
          </div>
          <div className="p-2 content-center">
            <div className="w-full">
              <InputInCard
                inCoin={inCoin}
                changeAmount={handle_in_amount}
                onRef={inRef}
              />
              <Divider>
                <div className="border-white border-opacity-25 h-[2px] py-2 bg-primary-200 rounded-2xl" />
              </Divider>
              <InputDateInCard
                setLockDuration={setLockDuration}
                lockDuration={lockDuration}
              />
            </div>
          </div>
          <div className="flex justify-between items-center p-4 pt-0 max-sm:flex-col gap-2">
            <div className="text-white font-bold">Expires</div>
            <div className="flex gap-5 max-sm:gap-3 max-sm:flex-wrap">
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                className="text-sm"
                defaultValue="1 week"
                onChange={changeDateOption}
              >
                <FormControlLabel
                  value="1 week"
                  control={<Radio size="small" />}
                  label="1 week"
                  className="text-white"
                />
                <FormControlLabel
                  value="1 month"
                  control={<Radio size="small" />}
                  label="1 month"
                  className="text-white"
                />
                <FormControlLabel
                  value="1 year"
                  control={<Radio size="small" />}
                  label="1 year"
                  className="text-white"
                />
                <FormControlLabel
                  value="4 years"
                  control={<Radio size="small" />}
                  label="4 years"
                  className="text-white"
                />
              </RadioGroup>
            </div>
          </div>
          <div className="flex justify-between items-center py-4 px-4">
            <div className="flex-col gap-2">
              <div className="text-white text-sm">
                Your voting power will be
              </div>
              <div className="text-white text-xl font-semibold">
                {inAmount
                  ? vePowerString(
                      ((lockDuration - now) * parseInt(inAmount, 10)) /
                        (365 * 4 * 86400)
                    )
                  : "0"}{" "}
                veNFT
              </div>
            </div>
            <div className="flex-col gap-2">
              <div className="text-opacity-50 text-sm text-white">
                {inAmount ? parseFloat(inAmount).toFixed(2) : "0.00"} FoilCoin
                locked expires {lockingString(lockDuration - now)}
              </div>
              <div className="text-opacity-50 text-sm text-white text-right">
                Locked until {getDateFormat1(new Date(lockDuration * 1000))}
              </div>
            </div>
          </div>
          <div className="h-px mx-4 bg-white opacity-10" />
          <div className="py-4 px-4 text-sm text-white text-opacity-50">
            <div>1 FoilCoin locked for 4 years = 1.00 veNFT</div>
            <div>1 FoilCoin locked for 3 years = 0.75 veNFT</div>
            <div>1 FoilCoin locked for 2 years = 0.50 veNFT</div>
            <div>1 FoilCoin locked for 1 years = 0.25 veNFT</div>
          </div>
        </Card>

        <div className="mt-1 p-1">
          {account ? (
            <Button
              disabled={lockBtnDisable}
              onClick={handle_lock}
              variant="contained"
              fullWidth
            >
              {lockBtnText}
            </Button>
          ) : (
            <LoginWallet local={1} />
          )}
        </div>
      </div>

      <div>
        <TransactionDialog
          openAlert={openAlert}
          txn={txn}
          title={`Lock  ${inAmount}  ${inSymbol} to 1  ${outSymbol}`}
          step={step}
          handleCloseAlert={handleCloseAlert}
        />
      </div>
    </div>
  );
}
